import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Optional
} from '@angular/core';
import {
  ActiveCartService,
  MultiCartService,
  OrderEntry,
  SelectiveCartService,
  UserIdService
} from '@spartacus/core';
import {
  CartItemComponentOptions,
  CartItemListComponent,
  OutletContextData
} from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { CartService } from '../../cart.service';

interface ItemListContext {
  readonly?: boolean;
  hasHeader?: boolean;
  options?: CartItemComponentOptions;
  cartId?: string;
  items?: OrderEntry[];
  cartIsLoading?: boolean;
}

interface iOption extends CartItemComponentOptions {
  displayAddToCart: false;
}

@Component({
  selector: 'cart-item-list',
  templateUrl: './cart-item-list.component.html',
  styleUrls: ['./cart-item-list.component.scss'],
})
export class CartItemListEkComponent
  extends CartItemListComponent
  implements OnInit, OnDestroy {
  entries: Observable<OrderEntry[]> | undefined;
  readonly: boolean = false;
  hasHeader: boolean = true;
  options: iOption = {
    isSaveForLater: false,
    optionalBtn: null,
    displayAddToCart: false,
  };
  cartId: string | any;
  isContinueBtnClick: boolean = false;
  responseCartLIstItem = [];
  afterSimulateAction: boolean = false;
  protected subscription = new Subscription();
  orderSimulateResp: any;
  updatedItem: any;
  constructor(
    protected activeCartService: ActiveCartService,
    protected selectiveCartService: SelectiveCartService,
    protected userIdService: UserIdService,
    protected multiCartService: MultiCartService,
    private cartService: CartService,
    protected cd: ChangeDetectorRef,
    @Optional() protected outlet?: OutletContextData<ItemListContext>
  ) {
    super(
      activeCartService,
      selectiveCartService,
      userIdService,
      multiCartService
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.afterSimulateAction = false;
    this.subscription.add(
      this.activeCartService.getEntries().subscribe((resp: any) => {
        if (resp) {
          this.items = resp;
        }
        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.cartService.cartEntryUpdates.subscribe((resp) => {
        if (resp?.length > 0) {
          this.afterSimulateAction = true;
          this.items = resp;
          this.orderSimulateResp = resp;
        }
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.cartService.cartEntryUpdates.next([]);
    this.subscription.unsubscribe();

  }

  removeEntry(item: OrderEntry): void {
    if (this.options.isSaveForLater) {
      this.selectiveCartService.removeEntry(item);
    } else if (this.cartId && this.userId) {
      this.multiCartService.removeEntry(
        this.userId,
        this.cartId,
        item.entryNumber as number
      );
    } else {
      this.activeCartService.removeEntry(item);
    }
    delete this.form.controls[this.getControlName(item)];
  }

  protected getControlName(item: OrderEntry): string {
    return item.entryNumber?.toString() || '';
  }

  qtyUpdateEvent($event: any) {
    this.updatedItem = $event;
  }

 
}
